module.exports = __webpack_public_path__ + "img/2.8a7f17e6.png";